/*@ngInject*/
const ComponentModel = function () {

    let selectedComponentId;

    this.getSelectedComponentId = function () {
        return selectedComponentId;
    };

    this.setSelectedComponentId = function (id) {
        selectedComponentId = id;
    };
};

angular.module('umFormViewer').service('componentModel', ComponentModel);
